module.exports = __webpack_public_path__ + "img/pfizer-medical-logo.7829533c.png";